import { Button } from "@devhop/ui";
import { MessageCircleIcon } from "lucide-react";
import { buildWhatsAppChatUrl } from "@/shared/lib/whatsapp";

type WhatsAppLinkButtonProps = {
  phone?: string | null;
  /** Full wa.me URL — if set, phone/message are ignored for URL building */
  href?: string | null;
  message?: string;
  label?: string;
  size?: "sm" | "default" | "icon";
  className?: string;
  iconOnly?: boolean;
};

export function WhatsAppLinkButton({
  phone,
  href,
  message,
  label = "WhatsApp",
  size = "sm",
  className,
  iconOnly = false,
}: WhatsAppLinkButtonProps) {
  const url =
    href ?? (phone?.trim() ? buildWhatsAppChatUrl(phone, message) : null);
  if (!url) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size={iconOnly ? "icon" : size}
      className={
        className ??
        (iconOnly
          ? "size-7 shrink-0 border-emerald-500/40 text-emerald-700 hover:bg-emerald-500/10 dark:text-emerald-400"
          : "h-7 gap-1 border-emerald-500/40 px-2 text-emerald-700 text-xs hover:bg-emerald-500/10 dark:text-emerald-400")
      }
      title={phone ? `ເປີດ WhatsApp: ${phone}` : "ເປີດ WhatsApp"}
      onClick={(e) => {
        e.stopPropagation();
        window.open(url, "_blank", "noopener,noreferrer");
      }}
    >
      <MessageCircleIcon className="size-3.5" />
      {!iconOnly ? label : null}
    </Button>
  );
}
